module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (200).ef0be26f.jpg";